let getWorkKeysUrl = 'http://192.168.169.243:8210/HxAccsseControl/getWorkKeys'

let UserInfo = {}
let user = ''

let isEncryption = true
let clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
let clientHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
let contentWidth = clientWidth - 170 + 'px'
let contentHeight = clientWidth - 80 + 'px'
let needLoadingRequestCount = 0
let ruleId = ''
let handleType = '0'
let initPageSize = 10
let initPageNum = 1
let timestamp = ''
let userId = ''
let userName = ''
let breadcrumbContent = []
let privileges = []
let treeProps = {
  children: 'childNodeList',
  label: 'nodeName'
}
let hideError = false
let noChangeTitle = '提交失败'
let noChangeMsg = '无法提交未修改的数据！'
let errorSubmit = '带红*的为必填项且必须填写正确！'
let departmentTree = []
let AreaTree = []
let departmentList = []
let menuList = []
let certTypeList = []
let personTypeList = []
let staffTypeList = []
let passTypeList = []
let deviceTypeList = []
let warnTypeList = []
let openModeList = []
let chooseDeviceList = []

let SystemPermission = {
  query: {functionId: '10101', functionName: '浏览'},
  update: {functionId: '10102', functionName: '修改'}
}

let InstitutionPermission = {
  add: {functionId: '20101', functionName: '新增'},
  update: {functionId: '20102', functionName: '修改'},
  query: {functionId: '20103', functionName: '浏览'},
  del: {functionId: '20104', functionName: '删除'}
}

let UserPermission = {
  add: {functionName: '新增', functionId: '30101', show: false},
  update: {functionName: '修改', functionId: '30102', show: false},
  cancel: {functionName: '注销', functionId: '30103', show: false},
  stopUse: {functionName: '停用', functionId: '30104', show: false},
  logout: {functionName: '释放登录状态', functionId: '30105', show: false},
  reset: {functionName: '重置密码及启用', functionId: '30106', show: false},
  queryRole: {functionName: '查询用户角色', functionId: '30107', show: false},
  setRole: {functionName: '角色分配', functionId: '30108', show: false},
  setArea: {functionName: '范围设置', functionId: '30109', show: false},
  queryArea: {functionName: '管理范围查询', functionId: '30110', show: false},
  query: {functionName: '查询', functionId: '30111', show: false}
}

let RolePermission = {
  add: {functionId: '30201', functionName: '新增'},
  update: {functionId: '30202', functionName: '修改'},
  query: {functionId: '30203', functionName: '查询'},
  del: {functionId: '30204', functionName: '删除'},
  queryRole: {functionId: '30205', functionName: '查询角色权限'},
  setRole: {functionId: '30206', functionName: '角色权限分配'}
}

let LogPermission = {
  query: {functionId: '30301', functionName: '浏览用户日志'}
}

let departmentPermission = {
  add: {functionId: '50101', functionName: '新增'},
  update: {functionId: '50102', functionName: '修改'},
  query: {functionId: '50103', functionName: '查询'},
  del: {functionId: '50104', functionName: '删除'}
}
let personPermission = {
  depAdd: {functionId: '50101', functionName: '部门-新增'},
  depUpdate: {functionId: '50102', functionName: '部门-修改'},
  depQuery: {functionId: '50103', functionName: '部门-查询'},
  depDel: {functionId: '50104', functionName: '部门-删除'},
  add: {functionId: '50201', functionName: '新增'},
  update: {functionId: '50202', functionName: '修改'},
  query: {functionId: '50203', functionName: '查询'},
  batchCreate: {functionId: '50204', functionName: '批量导入'},
  logout: {functionId: '50205', functionName: '注销'},
  freeze: {functionId: '50206', functionName: '冻结'},
  certInfo: {functionId: '50207', functionName: '通行凭证录入'},
  downLoadCard: {functionId: '50208', functionName: '下载卡数据'},
  delCard: {functionId: '50209', functionName: '删除卡数据'},
  getPic: {functionId: '50210', functionName: '获取照片'}
}
let devicePermission = {
  areaAdd: {functionId: '40101', functionName: '新增'},
  areaUpdate: {functionId: '40102', functionName: '修改'},
  areaQuery: {functionId: '40103', functionName: '查询'},
  areaDel: {functionId: '40104', functionName: '删除'},
  add: {functionId: '40201', functionName: '新增'},
  update: {functionId: '40202', functionName: '修改'},
  query: {functionId: '40203', functionName: '查询'},
  del: {functionId: '40204', functionName: '删除'},
  doorAdd: {functionId: '40301', functionName: '门新增'},
  doorUpdate: {functionId: '40302', functionName: '门修改'},
  doorQuery: {functionId: '40303', functionName: '门查询'},
  doorDel: {functionId: '40304', functionName: '门删除'},
  // setOpen: {functionId: '40305', functionName: '设置开放时段'},
  // updateOpen: {functionId: '40306', functionName: '修改开放时段'},
  // queryOpen: {functionId: '40307', functionName: '查询开放时段'},
  // delOpen: {functionId: '40308', functionName: '删除开放时段'},
  // remoteClose: {functionId: '40309', functionName: '远程关门'},
  // remoteOpen: {functionId: '40310', functionName: '远程开门'}
  setDoorParameter: {functionId: '40309', functionName: '设置门参数'},
  open: {functionId: '40310', functionName: '开门'},
  close: {functionId: '40311', functionName: '关门'},
  lock: {functionId: '40312', functionName: '锁门'},
  unlock: {functionId: '40313', functionName: '解锁'},
  keepOpen: {functionId: '40314', functionName: '长开'},
  alarm: {functionId: '40315', functionName: '开关警报'},
  connDevice: {functionId: '41201', functionName: '连接控制器'},
  setDeviceParameter: {functionId: '41202', functionName: '设置控制器参数'},
  downAllData: {functionId: '41203', functionName: '下载所有数据'},
  downLoadHoliday: {functionId: '41204', functionName: '下载假日'},
  downLoadDoorOpen: {functionId: '41205', functionName: '下载门开放时间'},
  clearHoliday: {functionId: '41206', functionName: '清除全部假日时间'},
  clearDoorOpen: {functionId: '41207', functionName: '清除全部门开放时间'},
  getDevConn: {functionId: '41208', functionName: '取控制连接状态'},
  getDevStatus: {functionId: '41209', functionName: '取门状态'},
  initDevice: {functionId: '41210', functionName: '复位门控制器'}
}
let deviceAreaPermission = {
  add: {functionId: '40101', functionName: '新增'},
  update: {functionId: '40102', functionName: '修改'},
  query: {functionId: '40103', functionName: '查询'},
  del: {functionId: '40104', functionName: '删除'}
}
let holidayPermission = {
  add: {functionId: '40401', functionName: '新增'},
  update: {functionId: '40402', functionName: '修改'},
  query: {functionId: '40403', functionName: '查询'},
  del: {functionId: '40404', functionName: '删除'}
}
// let devicePermission = {
//   add: {functionId: '40201', functionName: '新增'},
//   update: {functionId: '40202', functionName: '修改'},
//   query: {functionId: '40203', functionName: '查询'},
//   del: {functionId: '40204', functionName: '删除'}
// }
let doorPermission = {
  // add: {functionId: '40301', functionName: '新增'},
  // update: {functionId: '40302', functionName: '修改'},
  // query: {functionId: '40303', functionName: '查询'},
  // del: {functionId: '40304', functionName: '删除'},
  addOpen: {functionId: '40305', functionName: '设置开放时段'},
  updateOpen: {functionId: '40306', functionName: '修改开放时段'},
  queryOpen: {functionId: '40307', functionName: '查询开放时段'},
  delOpen: {functionId: '40308', functionName: '删除开放时段'}
  // remoteClose: {functionId: '40309', functionName: '远程关门'},
  // remoteOpen: {functionId: '40310', functionName: '远程开门'}
}
let PassRulePermission = {
  add: {functionId: '60101', functionName: '新增'},
  update: {functionId: '60102', functionName: '修改'},
  query: {functionId: '60103', functionName: '查询'},
  del: {functionId: '60104', functionName: '删除'},
  queryPassArea: {functionId: '60105', functionName: '查询通行范围'},
  setPassArea: {functionId: '60106', functionName: '设置通行范围'},
  queryPassArea2: {functionId: '60107', functionName: '查询通行范围二'}
}
let CommPassSettingPermission = {
  add: {functionId: '60201', functionName: '新增'},
  update: {functionId: '60202', functionName: '修改'},
  query: {functionId: '60203', functionName: '查询'},
  del: {functionId: '60204', functionName: '删除'},
  groupPermission: {functionId: '60210', functionName: '按组下载权限'}
}
let TempPassSettingPermission = {
  add: {functionId: '60301', functionName: '新增'},
  update: {functionId: '60302', functionName: '修改'},
  query: {functionId: '60303', functionName: '查询'},
  del: {functionId: '60304', functionName: '删除'},
  ownPermission: {functionId: '60310', functionName: '按个人下载权限'}
}
let PassHistoryPermission = {
  query: {functionId: '60401', functionName: '查询'},
  historyQuery: {functionId: '60402', functionName: '历史记录查询'},
  export: {functionId: '60403', functionName: '导出'}
}
let RealTimePassPermission = {
  query: {functionId: '60501', functionName: '查询'}
}

let ruleList = []
let personList = []
let doorList = []
let sysParameterList = []
let institutionList = []
let userList = []
let roleList = []
let deviceList = []
let doorOpenList = []
let holidayList = []
let tempPassSettingList = []
let areaList = []
let currentList = []
let commPassSettingList = []
let groupOption = []
// let tempPassSettingList = []

export default {
  UserInfo,
  user,
  getWorkKeysUrl,
  needLoadingRequestCount,
  groupOption,
  isEncryption,
  treeProps,
  hideError,
  ruleId,
  userId,
  handleType,
  userName,
  privileges,
  errorSubmit,
  noChangeTitle,
  noChangeMsg,
  breadcrumbContent,
  departmentTree,
  AreaTree,
  departmentList,
  certTypeList,
  personTypeList,
  staffTypeList,
  openModeList,
  chooseDeviceList,
  passTypeList,
  deviceTypeList,
  warnTypeList,
  UserPermission,
  RolePermission,
  LogPermission,
  SystemPermission,
  InstitutionPermission,
  departmentPermission,
  holidayPermission,
  deviceAreaPermission,
  personPermission,
  devicePermission,
  doorPermission,
  PassRulePermission,
  CommPassSettingPermission,
  TempPassSettingPermission,
  PassHistoryPermission,
  RealTimePassPermission,
  timestamp,
  initPageSize,
  initPageNum,
  clientWidth,
  clientHeight,
  contentWidth,
  contentHeight,
  ruleList,
  menuList,
  sysParameterList,
  institutionList,
  personList,
  doorOpenList,
  doorList,
  userList,
  commPassSettingList,
  // tempPassList,
  roleList,
  deviceList,
  holidayList,
  areaList,
  currentList,
  tempPassSettingList
}



// WEBPACK FOOTER //
// ./src/store/door_module/state.js